const questions = [
  {
    question:
      "What should I do If I made a mistake on my federal return that I’ve already filed?",
    answer:
      "You need to go for Amendment. Include copies of any forms and/or schedules that you’re changing or didn’t include with your original return. To avoid delays, file Form 1040-X only after you’ve filed your original return. Generally, for a credit or refund, you must file Form 1040-X within 3 years after the date you timely filed your original return or within 2 years after the date you paid the tax, whichever is later. Allow the IRS up to 16 weeks to process the amended return.",
  },
  {
    question: "I don’t owe taxes. Can I file electronically after April15?",
    answer: "",
  },
  {
    question: "How long it takes to file my tax returns?",
    answer: "",
  },
  {
    question: "How can I get my Tax Refund from the Departments?",
    answer: "",
  },
  {
    question: "How long the preparation process takes place?",
    answer: "",
  },
  {
    question: "What do I do if I receive a notice from the IRS about my taxes?",
    answer: "",
  },
  {
    question: "How long do I keep my records and tax returns?",
    answer: "",
  },
  {
    question:
      "What is the difference between a C corporation and S corporation?",
    answer: "",
  },
  {
    question:
      "What are the consequences of early withdrawals from my retirement plans?",
    answer: "",
  },
];
export default questions;
